import React from 'react';

// Job Filters card — per-filter enable toggle + schedule override entry point
export function JobFiltersList({ savedFilters, enabledFilters, filterConfigs, onToggleFilter, onConfigureFilter }) {
    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
            <div className="p-6 border-b border-gray-100">
                <div className="flex items-center gap-1 mb-1">
                    <h2 className="text-lg font-bold text-gray-900">Job Filters</h2>
                    <span className="text-red-500">*</span>
                </div>
                <p className="text-gray-500 text-sm">Select which filters to apply for notifications</p>
            </div>
            <div className="divide-y divide-gray-50">
                {savedFilters.length === 0 && (
                    <div className="p-6 text-center text-gray-500 text-sm">No saved filters found. Create one in the Dashboard first.</div>
                )}
                {savedFilters.map(filter => (
                    <div key={filter.id} className="p-4 px-6 flex items-center justify-between hover:bg-gray-50 transition-colors group">
                        <span className="text-gray-700 font-medium">{filter.name}</span>
                        <div className="flex items-center gap-4">
                            {enabledFilters[filter.id] && (
                                <button
                                    type="button"
                                    onClick={() => onConfigureFilter(filter.id)}
                                    className="group flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 px-3 py-1.5 rounded-lg transition-all"
                                >
                                    Schedule & Time
                                    <span
                                        className={`w-2 h-2 rounded-full transition-colors ${((filterConfigs[filter.id]?.frequency && filterConfigs[filter.id]?.frequency !== 'inherit') ||
                                            (filterConfigs[filter.id] && !filterConfigs[filter.id]?.useGlobalQuietHours))
                                            ? 'bg-green-500 shadow-sm'
                                            : 'bg-gray-300 group-hover:bg-gray-400'
                                            }`}
                                    />
                                </button>
                            )}
                            <button
                                type="button"
                                onClick={() => onToggleFilter(filter.id)}
                                aria-label={`Toggle notifications for ${filter.name}`}
                                className={`relative w-11 h-6 rounded-full transition-colors ${enabledFilters[filter.id] ? 'bg-blue-600' : 'bg-gray-200'}`}
                            >
                                <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${enabledFilters[filter.id] ? 'translate-x-5' : 'translate-x-0'}`} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
